// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import ahoy from "ahoy.js"

// Disable automatic visit/page tracking — handled server-side by Ahoy.
// JS client is only used for manual event tracking (gem copies).
ahoy.configure({ visitDuration: 4 * 60 })
ahoy.trackVisits = false
window.ahoy = ahoy
